import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreloaderModule } from '../preloader/preloader.module';
import { IconModule } from '../icon/icon.module';
import { ShareLinkComponent } from './share-link.component';


@NgModule({
  imports: [
    CommonModule,
    PreloaderModule,
    IconModule,
  ],
  declarations: [
    ShareLinkComponent,
  ],
  exports: [
    ShareLinkComponent,
  ],
  providers: []
})
export class ShareLinkModule {}
